import React from 'react';

const Result = ({ challenge }) => {
  return challenge?.results.length > 0 ? (
    <div className='space-y-2'>
      <h2 className='uppercase font-bold text-sm text-white'>
        expected results
      </h2>
      <ul className='list-none rounded-xl px-4 py-3 bg-tertiary/20'>
        {challenge.results.map((result, i) => (
          <li
            key={i}
            className='flex items-center gap-2'
          >
            <span>✅</span>
            <span className='text-white text-xs'>{result.result}</span>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default Result;
